<script setup lang="ts">
import { onMounted } from 'vue';
import Layout from '@/layout/Layout.vue';
import { useReferenceStore } from '@/stores/reference';

const reference = useReferenceStore();

// The store deliberately starts empty so a returning visitor's first client render matches the
// pre-rendered HTML, which was built without localStorage. onMounted on the root component runs
// after every child has mounted, so hydration is complete by the time this fires, and every
// consumer reads the store through a computed, so the updates propagate normally. The ordering
// and the reason both halves must wait live on initAfterHydration().
onMounted(() => {
  reference.initAfterHydration();
});
</script>

<template>
  <Layout>
    <RouterView />
  </Layout>
</template>
